import {usePushNotificationContext} from '../contexts/push-notification-with-context';

import type {OnCloseAllNote, OnCloseNote, OnCreateNote} from '../typedef';


type UsePushNotification = () => {
    onCreateNote: OnCreateNote,
    onCloseNote: OnCloseNote,
    onCloseAllNote: OnCloseAllNote,
};

/**
 * Returns the imperative notification API from the nearest `PushNotification`
 * context. Must be called inside a component tree wrapped by `PushNotification`.
 *
 * @returns `{ onCreateNote, onCloseNote, onCloseAllNote }` — callbacks to show
 * or dismiss toasts programmatically. Each callback returns a `Promise` that
 * resolves after the relevant animation completes.
 *
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/components-push-notification--documentation}
 */
export const usePushNotification: UsePushNotification = () => {
    const callbacks = usePushNotificationContext();

    return callbacks;
};
